<template>
  <div class="state-switch-checkbox">
    <label class="switch">
      <input
        :id="'checkbox'+qustionId"
        v-model="checkedValue"
        type="checkbox"
        :value="qustionId"
        @change="toggleSelect()"
      >
      <span class="slider round" />
    </label>
    <p
      v-if="select"
      class="dark"
    >
      {{ $t(selectText) }}
    </p>
    <p v-else>
      {{ $t(unSelectText) }}
    </p>
  </div>
</template>
<script>
export default {
  name: "StateSwitchCheckbox",
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    qustionId: {
      type: String,
    },
    selectText: {
      type: String,
      default() {
        return this.$t("顯示");
      },
    },
    unSelectText: {
      type: String,
      default() {
        return this.$t("隱藏");
      },
    },
  },
  data: () => ({
    select: false,
    checked_proxy: null,
  }),
  computed: {
    checkedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.checked_proxy = val;
      },
    },
  },
  mounted() {
    let checkBoxId = "checkbox" + this.qustionId;
    var checkBox = document.getElementById(checkBoxId);
    if (checkBox.checked == true) {
      this.select = true;
    } else {
      this.select = false;
    }
  },
  methods: {
    toggleSelect() {
      this.$emit("input", this.checked_proxy);
      this.select = !this.select;
      if (this.select) {
        this.$emit("fetch-action");
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/state-switch-checkbox";
</style>